document.addEventListener("DOMContentLoaded",Slpin(0), false);

function Slpin(mn){
  var mn_add = mn + 1;
  if(mn_add < 100){
    var huckle_class = document.getElementsByName("planOption").length;
    if(huckle_class > 0){
      setTimeout(function(){
        document.querySelectorAll(".product-form__buttons button[name='add']")[0].removeAttribute("disabled");
        var mn_add = 100;
      }, 300);
    }else{
      setTimeout(function(){Slpin(mn_add)}, 300);
    };
  };
};